var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M4.873 13.47c-.184.1-.4-.063-.364-.278l.597-3.653-2.53-2.587c-.149-.152-.067-.418.14-.449L6.21 5.97l1.564-3.323c.092-.196.358-.196.45 0L9.789 5.97l3.496.533c.206.031.288.297.139.449l-2.53 2.587.597 3.653c.035.215-.18.379-.364.277L8 11.745l-3.127 1.724z" })
  );
});